import { NavLink } from 'react-router-dom';
import { TenantSelector } from '../components/tms/tenant-selector/TenantSelector';
import { useMsal } from '@azure/msal-react';

// @ts-ignore
const Environment: string = import.meta.env.VITE_ENVIRONMENT_NAME;

const environments = [
  { label: 'DEV', url: 'https://demo.stratus.int.dev-newdaytechnology.net/' },
  { label: 'NFT', url: 'https://demo.stratus.int.nft-newdaytechnology.net/' },
  { label: 'STG', url: 'https://demo.stratus.int.stg-newdaytechnology.net/' },
];

export default function Header() {
  const { instance } = useMsal();
  const currentEnvironmentUrl = environments.find((environment) => Environment.startsWith(environment.label))?.url;

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: '/' });
  };

  const handleEnvironmentChange = (url: string) => {
    const environment = environments.find((environment) => environment.url === url);
    if (!environment) {
      return;
    }

    window.location.assign(environment.url);
  };

  return (
    <div className="ui menu" style={{ margin: '0px' }}>
      <div className="header item" style={{ border: 'none' }}>
        Stratus Demo UI - {Environment}
      </div>
      <NavLink to="/customers" className={`item`}>
        Customer
      </NavLink>
      <NavLink to="/accounts" className="item">
        Account
      </NavLink>
      <NavLink
        to="/tms"
        className="item"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
          gap: '0.25rem',
        }}>
        <span>Configuration</span>
        <small>(Read Only)</small>
      </NavLink>
      <div className="right menu">
        <div className="item">
          {/* @ts-ignore */}
          <a href={import.meta.env.VITE_GRAFANA_DASHBOARD_URI} target="_blank" rel="noopener noreferrer" className="ui button">
            Service Performance Dashboard
          </a>
        </div>
        <div className="item">
          <select
            aria-label="Environment"
            className="ui dropdown"
            value={currentEnvironmentUrl}
            onChange={(event) => handleEnvironmentChange(event.target.value)}>
            {environments.map((environment) => (
              <option key={environment.url} value={environment.url}>
                {environment.label}
              </option>
            ))}
          </select>
        </div>
        <div className="item">
          <TenantSelector />
        </div>
        <div className="item">
          <button className="ui button" onClick={handleLogout}>Log Out</button>
        </div>
      </div>
    </div>
  );
}
